import CenteredHeader from "../../Molecules/CenteredHeader/CenteredHeader";
import FS_HOME_ACERCA_BENEFICIO_SEGURIDAD_ICONO from "../../../assets/img/FS-HOME-ACERCA-BENEFICIO-SEGURIDAD-ICONO.svg";
import FS_HOME_ACERCA_BENEFICIO_INNOVACION_ICONO from "../../../assets/img/FS-HOME-ACERCA-BENEFICIO-INNOVACION-ICONO.svg";
import FS_HOME_ACERCA_BENEFICIO_COSTO_ICONO from "../../../assets/img/FS-HOME-ACERCA-BENEFICIO-COSTO-ICONO.svg";
import RegularCard from "../../Molecules/RegularCard/RegularCard";
import { Button } from "../../Atoms/Button/Button";
import "./HomeBenefitsSection.scss";
import content from "../../Pages/Home/content";
import { useLanguageCtx } from "../../../store/providers/LanguageContext";

function HomeBenefitsSection() {
	const {language} = useLanguageCtx();

	const CardsInf = [
		{
			img: FS_HOME_ACERCA_BENEFICIO_SEGURIDAD_ICONO,
			title: content[language].bienestarCardTitle,
			content: content[language].bienestarCardContent,
		},
		{
			img: FS_HOME_ACERCA_BENEFICIO_COSTO_ICONO,
			title: content[language].costosCardTitle,
			content: content[language].costosCardContent,
		},
		{
			img: FS_HOME_ACERCA_BENEFICIO_INNOVACION_ICONO,
			title: content[language].tecnologiaCardTitle,
			content: content[language].tecnologiaCardContent,
		},
	];

	return (
		<div className="top-space-section home">
			<CenteredHeader
				yellowText={content[language].beneficiosYellowTitle}
				boldText={content[language].beneficiosBoldText}
				route="home"
			/>
			<div className="max-width flex space-around wrap homeBenefits-cards-container top-space-section home">
				{CardsInf.map((inf) => (
					<RegularCard
						img={inf.img}
						title={inf.title}
						content={inf.content}
						key={inf.title}
						section="home-benefits-section"
					/>
				))}
			</div>
			<div className="max-width flex center-content-items mt-60">
				<Button
					type="button light-blue"
					content={content[language].beneficiosButtonContent}
				/>
			</div>
		</div>
	);
}

export default HomeBenefitsSection;
